import React from "react";

export function ErrorHandler() {
    return (
        <div className="categories-item__table-empty">Ничего не найдено</div>
    );
};